import Vue from 'vue'

const trackedBillUser = {
  state: {
    trackedBillUsers: [],
    selectedTrackedBillUser: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    trackedBillUsers(state) {
      return state.trackedBillUsers
    },
    selectedTrackedBillUser(state) {
      return state.selectedTrackedBillUser
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    trackedBillUsers(state, payload) {
      state.trackedBillUsers = payload
    },
    selectedTrackedBillUser(state, payload) {
      state.selectedTrackedBillUser = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedTrackedBillUser(context, payload) {
      context.commit('selectedTrackedBillUser', payload)
    },
    loadTrackedBillUsers(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillUser'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('trackedBillUsers', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    loadTrackedBillUsersForBill(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillUser/TrackedBill/${payload}`
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            // context.commit('trackedBillUsers', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedTrackedBillUser(context, payload) {
      if (
        context.state.selectedTrackedBillUser &&
        context.state.selectedTrackedBillUser.ID
      ) {
        context.dispatch(
          'loadSelectedTrackedBillUser',
          context.state.selectedTrackedBillUser.ID
        )
      }
    },
    loadSelectedTrackedBillUser(context, payload) {
      if (
        context.state.selectedTrackedBillUser &&
        context.state.selectedTrackedBillUser.ID != payload
      ) {
        context.commit('selectedTrackedBillUser', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillUser/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedTrackedBillUser', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadTrackedBillUsers(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadTrackedBillUsers')
      })
    },
    updateTrackedBillUser(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillUser/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill user updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillUsers')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createTrackedBillUser(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillUser`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill user created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillUsers')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveTrackedBillUser(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateTrackedBillUser', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createTrackedBillUser', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteTrackedBillUser(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillUser/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill user deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillUsers')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default trackedBillUser
